// React Components
import React from 'react';
import { Link } from 'react-router-dom';

// Ant Design Components
import { Tooltip } from 'antd';
import { UserOutlined } from '@ant-design/icons';

// Utilities & Helpers
import dayjs from 'dayjs';

// UI Components
import H3Text from '@Uilib/h3Text';

// Common Components
import ViewCustomFields from '@Components/Common/CustomField/ViewCustomFields';


const ViewPrDetails = ({ selectedPurchaseRequest }) => {
  const truncate = (str) =>
    str?.length > 25 ? `${str.substring(0, 25)}..` : str;

  return (
    <div className="document-header">
      <div className="ant-row">
        <div className="ant-col-md-24">
          <H3Text
            text={(
              <span>
                <UserOutlined />{' '}
                <span>
                  <Link>{selectedPurchaseRequest?.created_by_info?.first_name}</Link>
                </span>
              </span>
            )}
            className="document-header__party-name"
          />
        </div>

        <div className="ant-col-md-12">
          <Tooltip title={selectedPurchaseRequest?.tenant_info?.tenant_name}>
            <div className="document-header__field">
              <H3Text text="Requestor Location" className="document-header__field-name" />
              <H3Text text={truncate(selectedPurchaseRequest?.tenant_info?.tenant_name)} className="document-header__field-value" />
            </div>
          </Tooltip>
        </div>

        <div className="ant-col-md-12">
          <Tooltip title={selectedPurchaseRequest?.department_info?.department_name}>
            <div className="document-header__field">
              <H3Text text="Requestor Department" className="document-header__field-name" />
              <H3Text text={truncate(selectedPurchaseRequest?.department_info?.department_name)} className="document-header__field-value" />
            </div>
          </Tooltip>
        </div>

        {selectedPurchaseRequest?.issuer_tenant_id && (
          <div className="ant-col-md-12">
            <Tooltip title={selectedPurchaseRequest?.issuer_tenant_name}>
              <div className="document-header__field">
                <H3Text text="Issuer Location" className="document-header__field-name" />
                <H3Text text={truncate(selectedPurchaseRequest?.issuer_tenant_name)} className="document-header__field-value" />
              </div>
            </Tooltip>
          </div>
        )}

        {selectedPurchaseRequest?.issuer_tenant_department_id && (
          <div className="ant-col-md-12">
            <Tooltip title={selectedPurchaseRequest?.issuer_department_info?.department_name}>
              <div className="document-header__field">
                <H3Text text="Issuer Department" className="document-header__field-name" />
                <H3Text text={truncate(selectedPurchaseRequest?.issuer_department_info?.department_name)} className="document-header__field-value" />
              </div>
            </Tooltip>
          </div>
        )}

        <div className="ant-col-md-12">
          <div className="document-header__field">
            <H3Text text="Request Date" className="document-header__field-name" />
            <H3Text
              text={selectedPurchaseRequest?.created_at ? dayjs(selectedPurchaseRequest.created_at).format('DD/MM/YYYY') : '-'}
              className="document-header__field-value"
            />
          </div>
        </div>

        <div className="ant-col-md-12">
          <div className="document-header__field">
            <H3Text text="Delivery Date" className="document-header__field-name" />
            <H3Text
              text={selectedPurchaseRequest?.delivery_date ? dayjs(selectedPurchaseRequest.delivery_date).format('DD/MM/YYYY') : '-'}
              className="document-header__field-value"
            />
          </div>
        </div>

        {selectedPurchaseRequest?.custom_fields?.length > 0 && (
          <ViewCustomFields
            customFields={selectedPurchaseRequest.custom_fields.filter((cf) => cf.is_active)}
            wrapperClass="document-header__field"
            labelClass="document-header__field-name"
            valueClass="document-header__field-value"
            isHorizontal
          />
        )}
      </div>
    </div>
  );
};

export default ViewPrDetails;
